import axios from "@/plugins/axios";

import excel from "./excel";
import rows from "./rows";

let url = "/api/console/mes/boms";

export const boms = {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data.ecoNo}/${data.modelCode}/${data.revision}/${data.rank}`, data).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url}/${data.ecoNo}/${data.modelCode}/${data.revision}/${data.rank}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url}/${data.ecoNo}/${data.modelCode}/${data.revision}/${data.rank}`).then((result) => result.data);
    },

    excel,
    rows,
};

export default boms;
